import styled from 'styled-components'

export default styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: ${document.body.clientHeight - 52}px;
  width: 100vw;

  .products-infinite-scroll {
    padding-bottom: 50px;
  }

  .product-group-title {
    margin: 10px;
    margin-bottom: -5px;
    height: 23px;
    font-family: 'ABChanel PB SemiBold L', Arial, sans-serif;
    font-size: 17px;
    font-weight: normal;
    letter-spacing: -0.4px;
    text-align: center;
    color: #000000;

    &:first-child {
      margin-top: 50px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/styles/ProductSearchResultList.js